import { BpIcon, BpCheckedIcon } from './CustomCheckbox';

export { BpIcon, BpCheckedIcon };
